import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import MetaManager from "../Layout/MetaManager"; // ✅ Adjust path if needed

export default function BlogList() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetch("https://admin.socioloom.com/api/getAllBlogs.php")
      .then(res => res.json())
      .then(data => setBlogs(data))
      .catch(err => console.error("Error fetching blog data:", err));
      
          console.log("Blogs fetched:", blogs)
  }, []);

  return (
    <>
      <MetaManager slug="blog-list" />
    <div className="max-w-6xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-center mb-8">Our Blog</h1>
      <div className="grid gap-6 md:grid-cols-2">
        {blogs.map(blog => (
          <div key={blog.id} className="border rounded-xl overflow-hidden shadow-sm">
            <Link to={`/blog/${blog.slug}`}>
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-56 object-cover"
              />
              <div className="p-4">
                <h2 className="text-xl font-semibold text-blue-700 mb-2">{blog.title}</h2>
                <p className="text-gray-500 text-sm">{new Date(blog.created_at).toLocaleDateString()}</p>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
    </>
  );
}
